import axios from 'axios';
import logger from 'loglevel';

import {getCustomerUrl} from '~/utils/customer-util';
import {AccountingCode, Code, transform as codeTransform} from '../types/accounting-code-type';
import {StatusCodes} from "http-status-codes";

const LOG = logger.getLogger('WorktagService');

export default class CodeService {

    static async loadCodes(cNum: string, serverBase: string) {
        const url: string = getCustomerUrl(cNum,`${serverBase}/gltemplatenames`);
        const resp = await axios.get(url);
        if (resp.status === StatusCodes.OK) {
            const data: AccountingCode[] = resp.data._embedded.gLTemplateList;
            return data.map((code: AccountingCode) => codeTransform.fromApi(code));
        }
        return resp.status === StatusCodes.NO_CONTENT ? [] : undefined;
    }

    static async loadOneCode(cNum: string, serverBase: string, id: string) {
        const url: string = getCustomerUrl(cNum,`${serverBase}/gltemplates/${id}`);
        const resp = await axios.get(url);
        if (resp.status === StatusCodes.OK) {
            return codeTransform.fromApi(resp.data);
        }
        return resp.status === StatusCodes.OK ? resp.data : undefined;
    }

    static async updateOneCode(cNum: string, serverBase: string, code: Code) {
        const apiCode: AccountingCode = codeTransform.toApi(code);
        let resp;
        if (apiCode.id) {
            const url: string = getCustomerUrl(cNum, `${serverBase}/gltemplates/${apiCode.id}`);
            resp = await axios.put(url, apiCode);
        }
        else {
            const saveArray = [apiCode];
            const url: string = getCustomerUrl(cNum, `${serverBase}/gltemplates`);
            resp = await axios.post(url, saveArray);
        }
        LOG.info('Update an Accounting Code', apiCode.id);
        return resp;
    }

    static async deleteOneCode(cNum: string, serverBase: string, codeId: string) {
        const url: string = getCustomerUrl(cNum, `${serverBase}/gltemplates/${codeId}`);
        const resp = await axios.delete(url);
        LOG.info('Delete an Accounting Code', codeId);
        return resp;
    }
}
